/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { exists, mapValues } from '../runtime';
// @ts-ignore
import type { BillingAddress } from './BillingAddress';
// @ts-ignore
import {
// @ts-ignore
    BillingAddressFromJSON,
// @ts-ignore
    BillingAddressFromJSONTyped,
// @ts-ignore
    BillingAddressToJSON,
} from './BillingAddress';
// @ts-ignore
import type { BillingCustomer } from './BillingCustomer';
// @ts-ignore
import {
// @ts-ignore
    BillingCustomerFromJSON,
// @ts-ignore
    BillingCustomerFromJSONTyped,
// @ts-ignore
    BillingCustomerToJSON,
} from './BillingCustomer';

/**
 * Request payload to update billing contact and legal details. The customer field is system-admin-only; when omitted, the authenticated user's billing customer is used.
 * @export
 * @interface BillingDetailsUpdateRequest
 */
export interface BillingDetailsUpdateRequest {
    /**
     * 
     * @type {BillingCustomer}
     * @memberof BillingDetailsUpdateRequest
     */
    customer?: BillingCustomer;
    /**
     * 
     * @type {string}
     * @memberof BillingDetailsUpdateRequest
     */
    companyName: string;
    /**
     * Email address that receives invoices and billing notifications.
     * @type {string}
     * @memberof BillingDetailsUpdateRequest
     */
    billingEmail: string;
    /**
     * Tax or VAT identification number, if applicable.
     * @type {string}
     * @memberof BillingDetailsUpdateRequest
     */
    taxId?: string | null;
    /**
     * 
     * @type {BillingAddress}
     * @memberof BillingDetailsUpdateRequest
     */
    address?: BillingAddress;
}

/**
 * Check if a given object implements the BillingDetailsUpdateRequest interface.
 */
// @ts-ignore
export function instanceOfBillingDetailsUpdateRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "companyName" in value;
    isInstance = isInstance && "billingEmail" in value;

    return isInstance;
}

// @ts-ignore
export function BillingDetailsUpdateRequestFromJSON(json: any): BillingDetailsUpdateRequest {
    return BillingDetailsUpdateRequestFromJSONTyped(json, false);
}

// @ts-ignore
export function BillingDetailsUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): BillingDetailsUpdateRequest {
// @ts-ignore
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'customer': !exists(json, 'customer') ? undefined : BillingCustomerFromJSON(json['customer']),
        'companyName': json['company_name'],
        'billingEmail': json['billing_email'],
        'taxId': !exists(json, 'tax_id') ? undefined : json['tax_id'],
        'address': !exists(json, 'address') ? undefined : BillingAddressFromJSON(json['address']),
    };
}

// @ts-ignore
export function BillingDetailsUpdateRequestToJSON(value?: BillingDetailsUpdateRequest | null): any {
// @ts-ignore
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'customer': BillingCustomerToJSON(value.customer),
        'company_name': value.companyName,
        'billing_email': value.billingEmail,
        'tax_id': value.taxId,
        'address': BillingAddressToJSON(value.address),
    };
}

